import CitySEOHead from "@/components/feature/CitySEOHead";
import HeroSection from "./components/HeroSection";
import StickyNav from "./components/StickyNav";
import ProcessingTimeSection from "./components/ProcessingTimeSection";
import ServicesSection from "./components/ServicesSection";
import HowItWorksSection from "./components/HowItWorksSection";
import LocalAreaSection from "./components/LocalAreaSection";
import TestimonialsSection from "./components/TestimonialsSection";
import AcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import ComparisonSection from "./components/ComparisonSection";
import MistakesSection from "./components/MistakesSection";
import FAQSection from "./components/FAQSection";
import HelpfulResourcesSection from "./components/HelpfulResourcesSection";
import FinalCTA from "./components/FinalCTA";

const faqs = [
  { q: "How do I get an expedited passport in Helena, Montana?", a: "Helena residents can use Fast Passport Center for 2–9 day expedited processing. Ship documents overnight and we handle agency submission remotely. The nearest regional agency is in Denver, 500+ miles south." },
  { q: "Do Montana state government employees get any special passport considerations?", a: "No special federal government discounts apply, but Fast Passport Center frequently serves Helena state employees who need passports for international travel. Our service fits the busy schedules of government professionals." },
];

export default function HelenaPage() {
  return (
    <>
      <CitySEOHead
        city="Helena"
        state="Montana"
        stateAbbr="MT"
        route="/cities/helena"
        title="Emergency Passport Helena, MT — Expedited & Fast Passport Service | Fast Passport Center"
        description="Fast Passport Center provides emergency, expedited, and same-day passport services in Helena, Montana. Serving Lewis and Clark County, East Helena, Montana City, and surrounding areas. As fast as 24 hours — no Denver trip needed."
        geoPlacename="Helena, Montana"
        geoPosition="46.5958;-112.0270"
        faqs={faqs}
        servicesSchema={[]}
        statePageName="Montana"
        statePageRoute="/states/montana"
      />
      <div className="min-h-screen bg-white">
        <HeroSection />
        <StickyNav />
        <ProcessingTimeSection />
        <LocalAreaSection />
        <ServicesSection />
        <HowItWorksSection />
        <TestimonialsSection />
        <AcceptanceFacilitiesSection />
        <ComparisonSection />
        <MistakesSection />
        <FAQSection />
        <HelpfulResourcesSection />
        <FinalCTA />
      </div>
    </>
  );
}